import { escapeHtml } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** faq — accessible native disclosure items. */
export function renderFaq(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const items = list(section.fields, 'items')
    .map((item, index) => {
      const question = itemStr(item, 'question');
      const answer = itemStr(item, 'answer');
      if (!question && !answer) return '';
      const itemPath = `/items/${index}`;
      const lines = [`    <details class="ve-faq__item"${editAttr(section, itemPath)}>`];
      if (question) lines.push(`      <summary class="ve-faq__question">${escapeHtml(question)}</summary>`);
      if (answer) lines.push(`      <p class="ve-faq__answer">${escapeHtml(answer)}</p>`);
      lines.push('    </details>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'faq', heading, label),
    itemCollection(section, 'div', 've-faq__items', '/items', items),
    '</section>',
  ];
  return parts.join('\n');
}
